import _ from 'underscore';

export default {
  Checkout: require('./checkout').default,
  Confirmation: require('./confirmation').default,
  TourFilters: require('./tour_filters').default,
  Header: require('./header').default,
  Tours: require('./tours').default,
  GlobalError: require('./global_error').default,
  UI: _.extend({}, require('./ui').default, {
    Modal: require('views/shared/ui/modal').default,
  }),
};
